import { decodeHtml } from '@Utils'

// Generated labels only: a title may itself start with a number.
// A branch's label is a word and a number ("Chapter 2", "Appendix A"), an appendix code ("A1") or,
// for a chapter inside a part, a dotted number ("2.1"); a page's is the number alone ("2.1", "A1.3").
export function tocLabel(itemTitle, label, rawTitle, branch) {
  const title = decodeHtml(itemTitle || '')
  const generated = decodeHtml(label || '')
  const match = branch
    ? /^\p{L}+\.? (\d{1,2}|[A-Z])$/u.exec(generated) ||
      /^([A-Z]\d?|\d+\.\d+(?:\.\d+)*)$/.exec(generated)
    : /^((?:\d+|[A-Z]\d?)(?:\.\d+)*)$/.exec(generated)
  return {
    title,
    number: match ? match[1] : undefined,
    visibleTitle: match
      ? decodeHtml(rawTitle || (branch ? 'Chapter Title' : 'No Title'))
      : title,
  }
}

// The width of the longest page number among siblings, so their titles line up.
// A digit is 1ch in tabular figures; a dot is about a third of that.
export function tocNumberWidth(items) {
  const widths = items
    .map(item => decodeHtml(item.label || ''))
    .filter(label => /^(?:\d+|[A-Z]\d?)(?:\.\d+)*$/.test(label))
    .map(label => label.length - (label.split('.').length - 1) * 0.65)
  return widths.length ? `${Math.max(...widths)}ch` : undefined
}
